import * as ActionTypes from '../actions/actionTypes';
import createReducer from '../../util/createReducer';

const INITIAL_STATE = {
  'show': false,
};

export const messageBox = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.MESSAGE_BOX_DISMISSED]: (state, action) => ({
      'show': action.payload.showMessage,
    }),
    [ActionTypes.MESSAGE_BOX_ERROR_ADDED]: (state, action) => ({
      'show': action.payload.showMessage,
      'error': action.payload.error,
    }),
    [ActionTypes.MESSAGE_BOX_WARNING_ADDED]: (state, action) => ({
      'show': action.payload.showMessage,
      'warning': action.payload.warning,
    }),
    [ActionTypes.MESSAGE_BOX_INFO_ADDED]: (state, action) => ({
      'show': action.payload.showMessage,
      'info': action.payload.info,
    }),
    [ActionTypes.MESSAGE_BOX_CUSTOM]: (state, action) => ({
      'show': action.payload.showMessage,
      [action.payload.data.type]: action.payload.data.typeValue,
      'hideTime': action.payload.data.hideTime,
    }),
  })(state, action);
};
